module.exports = __webpack_public_path__ + "media/images/icons/home-05af81a5ad5951a5dbc0c4ad7d9e8be0.svg";